const React = require('react')
const PropTypes = require('prop-types')
const hasFeature = require('module/user/helpers/has_feature')
const isAllowedFeature = require('module/user/helpers/is_allowed_feature')
const { getTestimonialsHeader } = require('module/user/helpers/get_testimonials_header')
const TestimonialItem = require('./testimonial_item')
const config = require('lib/config')

function Testimonials({ user, color, luminance }) {

    // don't render if user is not allowed this feature
    // e.g. an expired pro user
    if (! isAllowedFeature(user, 'testimonials')) return null

    // don't render if user has not added this feature
    if (! hasFeature(user, 'testimonials')) return null

    const { testimonials } = user

    const max_items = config.get('client.testimonials.items.max_length', 3)
    const items = (
        testimonials.items
            .filter(item => !! item.quote)
            .slice(0, max_items)
    )
    if (! items.length) return null

    const header = getTestimonialsHeader(testimonials)

    const accent_color = (
        luminance === 'dark'
            ? `#${color}`
            : '#333'
    )

    return (
        <section className="testimonials inset" style={{ color: accent_color }}>
            <div className="meta-header">{header}</div>
            <div className="testimonial-items">
                {
                    items.map((item, i) => {
                        return <TestimonialItem key={i} item={item} color={accent_color} />
                    })
                }
            </div>
        </section>
    )
}

Testimonials.propTypes = {
    user: PropTypes.object.isRequired,
    color: PropTypes.string.isRequired,
    luminance: PropTypes.oneOf([
        'light',
        'dark',
    ]).isRequired,
}

module.exports = Testimonials
